import { AdditionalInfoStep as SharedAdditionalInfoStep } from "../../../../../shared/additional-info/AdditionalInfoStep";
import type { BondRequestFormValues } from "../../schema";

export const AdditionalInfoStep = () => (
	<SharedAdditionalInfoStep<BondRequestFormValues>
		commentPath="quote.additionalInfo.comment"
		attachmentsPath="quote.additionalInfo.attachments"
	/>
);
